/**
 * Session management for analytics.
 * Generates a unique sessionId per browser tab, stored in sessionStorage.
 */

const SESSION_ID_KEY = 'node_analytics_session_id';

/**
 * Generates a UUID v4
 * @returns {string} UUID
 */
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Returns the session ID for the current tab.
 * Creates one if it doesn't exist (unique per tab via sessionStorage).
 * @returns {string} Session ID
 */
export function getSessionId() {
  try {
    let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
    if (!sessionId) {
      sessionId = generateUUID();
      sessionStorage.setItem(SESSION_ID_KEY, sessionId);
    }
    return sessionId;
  } catch {
    // Fallback if sessionStorage is unavailable (e.g., private browsing)
    return generateUUID();
  }
}

/**
 * Generates a unique request ID (UUID v4)
 * @returns {string} Request ID
 */
export function generateRequestId() {
  return generateUUID();
}

